import i18n from "../i18n"

/**
 * Get ISO code from i18n locale
 *
 * @returns {string} ISO code
 */
export function getIsoLanguage() {
    switch (i18n.global.locale.value) {
        case "fr":
            return "fr-FR"
        case "en":
        case "dk":
        case "fi":
        case "no":
        case "se":
            return "en-GB"
        case "de":
            return "de-DE"
        case "nl":
        case "fl":
            return "nl-NL"
        case "es":
            return "es-ES"
        case "it":
            return "it-IT"

        default:
            return "en-GB"
    }
}

/**
 * Format date to meet the expectations of each country
 *
 * @param {string} newDate - Date to format. Need to be "YYYY-MM-DD HH:MM:SS"
 *
 * @returns {string} Formated date
 */
export function formatDateWithCountry(newDate) {
    if (!newDate) return

    const [date, time] = newDate.split(" ")
    const [year, month, day] = date.split("-")

    switch (i18n.global.locale.value) {
        case "fr":
        case "en":
        case "es":
        case "fi":
        case "no":
        case "se":
        case "de":
        case "fl":
        case "it":
            return `${day}/${month}/${year} ${time}`

        case "dk":
        case "nl":
            return `${day}-${month}-${year} ${time}`

        default:
            return `${day}/${month}/${year} ${time}`
    }
}
